<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
	<component :is="as" class="scrollable-item">
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		as?: string;
	}>(),
	{
		as: "div",
	},
);
</script>
